import { createRoutine } from 'redux-saga-routines';

export const fetchSmtpAccounts = createRoutine('FETCH_SMTP_ACCOUNTS');
export const createSmtpAccount = createRoutine('CREATE_SMTP_ACCOUNT');
export const updateSmtpAccount = createRoutine('UPDATE_SMTP_ACCOUNT');
export const deleteSmtpAccount = createRoutine('DELETE_SMTP_ACCOUNT');
